module.exports = __webpack_public_path__ + "img/23i.54097ac4.png";